function Oman({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1843)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M0 15.9999C0 22.0646 3.37438 27.3408 8.34781 30.0544V1.94531C3.37438 4.65894 0 9.93518 0 15.9999Z" fill="#D80027"/>
  <path d="M31.0049 21.5649C31.648 19.8316 32 17.9569 32 15.9998C32 14.0426 31.648 12.1678 31.0049 10.4346H0.99525C0.352062 12.1678 0 14.0426 0 15.9998C0 17.9569 0.352062 19.8316 0.99525 21.5649L16 22.9563L31.0049 21.5649Z" fill="#D80027"/>
  <path d="M16 32.0002C22.8795 32.0002 28.7441 27.6582 31.0049 21.5654H0.995239C3.25586 27.6582 9.12061 32.0002 16 32.0002Z" fill="#6DA544"/>
  <path d="M0 15.9996C0 23.392 5.01381 29.6124 11.8261 31.4484V0.550781C5.01381 2.38678 0 8.60716 0 15.9996Z" fill="#D80027"/>
  <path d="M9.78851 7.04112L8.31282 5.56543L7.32907 6.5493L6.34532 5.56543L4.86963 7.04112L5.85344 8.02493L4.86951 9.0088L6.34519 10.4845L7.32901 9.50062L8.31282 10.4845L9.78851 9.0088L8.80469 8.02493L9.78851 7.04112Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Oman;
